import React, { useState } from "react";
import "./sidebar.scss";
import {
  Wrench,
  Anchor,
  Layout,
  Globe,
  Users,
  Gamepad2,
  BadgeCheck,
  ScrollText,
  ShieldCheck,
  ListChecks,
  Image,
} from "lucide-react";

import { useNavigate } from "react-router-dom";

import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import { FaArrowRightLong, FaRightFromBracket } from "react-icons/fa6";
import logo from "../../assets/images/logo/horizontal-logo-green-text -blue.png";
import { IoIosCloseCircle } from "react-icons/io";

import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";
import Button from "../Button/Button";
import { useDispatch } from "react-redux";
import { openRoles, openSkills } from "../../store/Partner/modalSlice";
import Badge from "../Badge/Badge";

const Sidebar = ({ userData, setShowSideBar }) => {
  const showUserProfile = () => {};
  const navigate = useNavigate();
  const [navLinks, setNavLinks] = useState(false);
  const [socialLinks, setSocialLinks] = useState(false);
  const [showSkills, setShowSkills] = useState(false);

  const dispatch = useDispatch();

  const handleOpenRoles = () => {
    dispatch(openRoles());
  };

  const handelOpenSkills = () => {
    dispatch(openSkills());
  };
  const handleLogout = () => {
    // Clear all cookies
    document.cookie.split(";").forEach((cookie) => {
      const name = cookie.split("=")[0].trim();
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });

    // Clear local storage
    localStorage.clear();

    // Optionally, clear session storage too
    sessionStorage.clear();

    navigate("/", { replace: true });
  };

  const controls = [
    {
      id: 1,
      title: "Dashboard",
      url: "/dashboard",
      icon: <Layout size={14} style={{ marginRight: "8px" }} />,
    },
    {
      id: 2,
      title: "Equipments",
      url: "/dashboard/equipments",
      icon: <Gamepad2 size={14} style={{ marginRight: "8px" }} />,
    },
    {
      id: 3,
      title: "Drone Pilot License",
      url: "/dashboard/licenses",
      icon: <BadgeCheck size={14} style={{ marginRight: "8px" }} />,
    },
    {
      id: 4,
      title: "Certificates",
      url: "/dashboard/certificates",
      icon: <ScrollText size={14} style={{ marginRight: "8px" }} />,
    },
    {
      id: 5,
      title: "Verification",
      url: "/dashboard/kycdocuments",
      icon: <ShieldCheck size={14} style={{ marginRight: "8px" }} />,
    },
     {
      id: 6,
       title: "Social Links",
       url: "/dashboard/social",
       icon: <Globe size={14} style={{ marginRight: "8px" }} />,
    },
    {
      id: 7,
      title: "Services Offered",
      url: "/dashboard/services",
      icon: <ListChecks size={14} style={{ marginRight: "8px" }} />,
    },
    {
      id: 8,
      title: "Gallery",
      url: "/dashboard/gallery",
      icon: <Image size={14} style={{ marginRight: "8px" }} />,
      isComingSoon:true
    },
    
  ];

  const socialMedia = [
    {
      id: 1,
      title: "LinkedIn",
      url: "/dashboard/partner/edit-profile",
      icon: <FaLinkedinIn className="social-icons" />,
    },
    {
      id: 2,
      title: "Facebook",
      url: "/dashboard/partner/edit-profile",
      icon: <FaFacebookF className="social-icons" />,
    },
    {
      id: 3,
      title: "Instagram",
      url: "/dashboard/partner/edit-profile",
      icon: <FaInstagram className="social-icons" />,
    },
    {
      id: 4,
      title: "Youtube",
      url: "/dashboard/partner/edit-profile",
      icon: <FaYoutube className="social-icons" />,
    },
  ];

  const goToDashboard = () => {
    navigate("/dashboard");
  };
  
  return (
    <div className="sidebar-container">
      <IoIosCloseCircle
        className="sideBarClose"
        onClick={() => setShowSideBar(false)}
        size={26}
      />
      <div className="sideBar-logo">
        <div className="image-container">
          <img src={logo} alt="" onClick={goToDashboard} />
        </div>
      </div>

      <div className="sidebar-control-options">
        <div className="btn-section">
          <span>Profile Guide</span>
          <button className="profile-guide-btn" onClick={()=>navigate('how-we-work')}>
            How Aerial Borne works?
          </button>
          <button className="whats-new-btn" >
            What's new?
          </button>
        </div>

        <div className="controll-options-container">
          <div className="nav-options-container">
            <div className="nav-option-header">
              <h5>Profile</h5>
            </div>

            {/* Container */}
            {/* <div className="nav-options-container"> */}

            {/* roles */}
            <div className="sub-options" onClick={handleOpenRoles}>
              <div className="nav-option-items">
                <span>
                  {" "}
                  <Wrench size={14} style={{ marginRight: "8px" }} />
                  Roles
                </span>
              </div>
            </div>

            {/* Skills */}
            <div className="sub-options"  onClick={handelOpenSkills}   >
              <div
                className="nav-option-items"
                onClick={() => {
                  setNavLinks(false);
                  setSocialLinks(false);
                  setShowSkills(!showSkills);
                }}
              >
                <span>
                  {" "}
                  <Anchor size={14} style={{ marginRight: "8px" }} />
                  Skills
                </span>
                {/* {showSkills ? <FaAngleUp /> : <FaAngleDown />} */}
              </div>
              {/* {showSkills && (
                <div>
                  <div className="skills-flex">
                    {userData && userData.partner.skills.length > 0 ? (
                      userData.partner.skills.map((skill, index) => (
                        <div key={index} className="skills-items">
                          <p>{skill.skill_name} </p>
                        </div>
                      ))
                    ) : (
                      <p>No Skills Added yet</p>
                    )}
                  </div>
                  <div className="see-all-btn-cont">
                    <Button
                      fullWidth={true}
                      label={"Add More Skills"}
                      handleClick={handelOpenSkills}
                      className={"see-all-btn"}
                    />
                  </div>
                </div>
              )} */}
            </div>

            {/* Create your website */}
            <div className="sub-options disabled" onClick={""}>
              <div className="nav-option-items">
                <span>
                  <Layout size={14} style={{ marginRight: "8px" }} /> Create
                  your Website
                </span>
                <Badge text="Coming soon" />
              </div>
            </div>

            {/* </div> */}

            <div>
              <div className="nav-option-header">
                <h5>Missions</h5>
              </div>

              {/* roles */}
              <div className="sub-options disabled" onClick={""}>
                <div className="nav-option-items">
                  <span>
                    <Globe size={14} style={{ marginRight: "8px" }} /> Open in
                    network 
                  </span> 

                  <Badge text="Coming soon"/>
                </div>
              </div>

              <div className="sub-options disabled" onClick={""}>
                <div className="nav-option-items">
                  <span >
                    <Users size={14} style={{ marginRight: "8px" }} />
                    Only for you
                  </span>
                  <Badge text="Coming soon"/>
                </div>
              </div>
            </div>
            {/* </div> */}

            <div
              className="nav-option-header"
              onClick={() => {
                setSocialLinks(false);
                setShowSkills(false);
              }}
            >
              <h5>Product Shortcuts</h5>
            </div>

            <div className="sub-options">
              {controls.map((item) => (
                <div className={`${item.isComingSoon?"disabled":""}`}>
                <p
                  key={item.id}
                  className="nav-option-items"
                  onClick={() => {
                    navigate(item.url);
                  }}
                >
                  <span>
                    {item.icon} {item.title}
                  </span>
                  {item.isComingSoon && <Badge text="Coming soon"/>}
                </p>
                </div>
              ))}
            </div>
          </div>
          <Button
            handleClick={handleLogout}
            label={"Logout"}
            icon={<FaRightFromBracket />}
            iconPosition="left"
            fullWidth={true}
            customStyle={{
              backgroundColor: "#000112",
              color: "white",
              justifyContent: "center",
              marginBottom: "36px",
            }}
          />
          <div className="sidebar-btn-container"></div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
